var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-15"},[_c('MattrzBaseLogo',{attrs:{"width":"350"}}),_vm._v(" "),_c('div',{staticClass:"pa-4 mx-auto my-5",staticStyle:{"width":"400px"}},[_c('AcceptInvitationContainer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }